export default function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 pb-5 border-b hairline mb-8 fade-up" data-testid={testid || "page-header"}>
      <div>
        <div className="overline mb-2">{subtitle || ""}</div>
        <h1 className="font-display text-4xl sm:text-5xl leading-none text-slate-900 tracking-tight">{title}</h1>
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}
